import React from "react";

const ToolbarDivider: React.FC = () => (
  <div className="w-[1px] h-4 bg-border-border1" />
);

export default ToolbarDivider;
